

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  handleNavigation,
  handleAnchorNavigation,
  handleMenuClick,
} from '../utils/navigationsHandlers';
import { Helmet } from "react-helmet-async";



const Ajuda = () => {


  const navigate = useNavigate();

  const [toc, setToc] = useState([]);
  const [openItem, setOpenItem] = useState(null);
 



  useEffect(() => {
    const headings = Array.from(
      document.querySelectorAll(
        '.termos-text h2:not(.no-toc), .termos-text h3:not(.no-toc), .termos-text h5:not(.no-toc)'
      )
    ).map((el) => ({
      id: el.id,
      text: el.innerText,
      level: el.tagName,
    }));
    setToc(headings);
  }, []);

  const scrollToAnchor = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const toggleItem = (id) => {
    setOpenItem((prev) => (prev === id ? null : id));
  };

  // agrupa os H4 dentro dos H3
  const groupedToc = toc.reduce((acc, item) => {
    if (item.level === 'H3') {
      acc.push({ ...item, children: [] });
    } else if (item.level === 'H5') {
      if (acc.length) acc[acc.length - 1].children.push(item);
    }
    return acc;
  }, []);





  return (
    <div id="topo-termos-page" className="termos-page">

    <Helmet>
      <title>Dúvidas e Ajuda sobre Revisão de Aposentadoria | Revisa Já</title>

      <meta
        name="description"
        content="Tire suas dúvidas sobre como funciona a revisão de aposentadoria na prática. Entenda o passo a passo para corrigir erros como PSC-MEN-SM-EC103 e recuperar o que é seu por direito."
      />

      <meta
        name="keywords"
        content="como funciona a revisão de aposentadoria, dúvidas inss, revisão de aposentadoria passo a passo, quando pedir revisão de aposentadoria, erro no cálculo inss, PSC-MEN-SM-EC103, PREC-MENOR-MIN"
      />

      <meta property="og:title" content="Central de Ajuda: Tire suas Dúvidas sobre Revisão INSS" />
      <meta
        property="og:description"
        content="Precisa de ajuda para entender sua aposentadoria? Confira as respostas para as perguntas mais comuns e veja como garantir seu direito."
      />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://revisajaaposentadoria.com.br/ajuda" />
      <meta property="og:image" content="https://revisajaaposentadoria.com.br/assets/og-ajuda.png" />
      
      <link rel="canonical" href="https://revisajaaposentadoria.com.br/ajuda" />
    </Helmet>



      <div className='termos-box'>
        <div className='termos-text'>

          <h2 className='dark-green-underline no-toc'>AJUDA</h2>



          <div className='center small-top-margin'>
            <ul className="sumario">
              <li>Sumário</li>
              {groupedToc.map((item) => (
                <li key={item.id} className="nivel-h3">
                  <div className="toc-item">
                    {/* texto que navega */}
                    <span
                      className="toc-text"
                      onClick={() => scrollToAnchor(item.id)}
                      style={{ cursor: 'pointer' }}
                    >
                      {item.text}
                    </span>

                    {/* seta para expandir H4 */}
                    {item.children.length > 0 && (
                      <span
                        className="toc-toggle"
                        onClick={(e) => {
                          e.stopPropagation(); // evita scroll ao clicar na seta
                          toggleItem(item.id);
                        }}
                        style={{ cursor: 'pointer', marginLeft: '8px' }}
                      >
                        {openItem === item.id ? 'Recolher ▲' : 'Expandir ▼'}
                      </span>
                    )}
                  </div>

                  {/* subitens H4 */}
                  {openItem === item.id && item.children.length > 0 && (
                    <ul className="nivel-h5">
                      {item.children.map((child) => (
                        <li
                          key={child.id}
                          className="nivel-h5-item"
                          onClick={() => scrollToAnchor(child.id)}
                          style={{ cursor: 'pointer' }}
                        >
                          {child.text}
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>




          {/* 1- INICIANDO A REVISÃO */}

          <h3 id="iniciando-revisao" className='top-margin underline'>1. Iniciando sua revisão</h3>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Na página inicial do nosso site, clique no botão <strong className='ind-btn'>“Revisar agora”</strong> para dar início à sua Revisão <a href='https://www.youtube.com/watch?v=TFCeZJi8-OI' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></p>
          </ul>

          <p>Para realizar a revisão de cálculos são necessários o CNIS e a Carta de Concessão, que podem ser obtidos no site do MEU INSS.</p>


          


          {/* 2- ENTRANDO NO MEU INSS */}

          <h3 id="entrando-meu-inss" className='medium-top-margin underline'>2. Entrando no meu INSS</h3>
          <p>É necessário que você tenha o aplicativo Gov.br em seu celular.</p>

          <h5 id="login" className='top-margin'>2.1 - Login - <a href='https://youtu.be/TFCeZJi8-OI?t=17' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Abra o aplicativo MEU INSS no seu celular para fazer o login.</p>
            <p><span className='roman'>II)</span> No site ou aplicativo, clique em <strong className='ind-btn'>“Entrar com gov.br”</strong>.</p>
            <p><span className='roman'>III)</span> Digite seu CPF e depois clique em <strong className='ind-btn'>“Continuar”</strong>.</p>
            <p><span className='roman'>IV)</span> Agora digite sua senha e clique em <strong className='ind-btn'>“Entrar”</strong>.</p>
          </ul>



          <p className='top-margin'>Links de acesso:</p>
          <p><a href='https://meu.inss.gov.br/'>https://meu.inss.gov.br/</a></p>
          <p><a href='https://www.gov.br/pt-br'>https://www.gov.br/pt-br</a></p>




          <h5 id="autenticacao-2etapas" className='top-margin'>2.2 - Autenticação de duas etapas - <a href='https://youtu.be/TFCeZJi8-OI?t=74' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Na tela de Verificação em duas etapas, clique em <strong className='ind-btn'>“Gerar código de acesso”</strong>.</p>
            <p><span className='roman'>II)</span> O sistema perguntará se deseja abrir com o Gov.br, clique em <strong className='ind-btn'>“Abrir”</strong>.</p>
            <p><span className='roman'>III)</span> Em seguida, clique em <strong className='ind-btn'>“Copiar Código”</strong> — você tem um minuto e cinquenta segundos para efetuar essa etapa.</p>
            <p><span className='roman'>IV)</span> Volte ao Meu INSS, clique em <strong className='ind-btn'>“Código de acesso”</strong>, depois em <strong className='ind-btn'>“Colar”</strong> e depois clique em <strong className='ind-btn'>“Ok”</strong>.</p>
            <p><span className='roman'>VI)</span> Clique em <strong className='ind-btn'>“Autorizar”</strong> e pronto — conseguiu acessar o Meu INSS.</p>
          </ul>



          


          {/* 3- BAIXANDO DOCUMENTOS */}

          <h3 id="baixando-documentos" className='medium-top-margin underline'>3. Baixando seus documentos</h3>
          <h5 id="baixando-cnis" className='top-margin'>3.1 - Baixando o CNIS - <a href='https://youtu.be/TFCeZJi8-OI?t=123' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Na tela do Meu INSS, clique na lupa de pesquisa e digite CNIS.</p>
            <p><span className='roman'>II)</span> Depois, clique no meio em <strong className='ind-btn'>“Extrato de Contribuições (CNIS)”</strong>.</p>
            <p><span className='roman'>III)</span> Aqui na parte inferior da tela, clique em <strong className='ind-btn'>“Baixar documento”</strong> e selecione a opção <strong className='ind-btn'>“Vínculos, contribuições e remunerações”</strong>, depois clique aqui em <strong className='ind-btn'>“Salvar”</strong>.</p>
          </ul>
          <p>Pronto, o documento foi baixado com sucesso!</p>


          <h5 id="baixando-carta" className='top-margin'>3.2 - Baixando a Carta de Concessão - <a href='https://youtu.be/TFCeZJi8-OI?t=274' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Volte à tela do Meu INSS, digite “Carta de Concessão” na lupa.</p>
            <p><span className='roman'>II)</span> clique em <strong className='ind-btn'>“Carta de Concessão de Benefício”</strong>, depois em <strong className='ind-btn'>“Carta de Concessão”</strong> e, por fim, em <strong className='ind-btn'>“Baixar Carta de Concessão”</strong>.</p>
          </ul>




          {/* 4- ENVIANDO DOCUMENTOS */}

          <h3 id="enviando-documentos" className='medium-top-margin underline'>4. Enviando seus documentos</h3>
          <p>Agora que você já baixou a Carta de Concessão e o CNIS, é hora de anexar os arquivos no site.</p>

          <h5 id="enviando-cnis" className='top-margin'>4.1 - Enviando seu CNIS para o Revisa Já - <a href='https://youtu.be/TFCeZJi8-OI?t=123' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Volte ao site do Revisa Já e clique em <strong className='ind-btn'>CNIS/PDF</strong> — o sistema abrirá a tela de documentos do seu celular.</p>
            <p><span className='roman'>II)</span> Procure pelos arquivos baixados (CNIS e Carta de Concessão) — geralmente eles ficam em Downloads ou Arquivos recentes.</p>
            <p><span className='roman'>III)</span> Não achou? Pode ter ido para o Drive. Abra o Drive, clique nas três linhas no canto superior esquerdo, depois em <strong className='ind-btn'>“Recentes”</strong>, depois em <strong className='ind-btn'>“meu drive”</strong>.</p>
          </ul>


          <h5 id="enviando-carta" className='top-margin'>4.2 - Enviando sua Carta de Concessão para o Revisa Já - <a href='https://youtu.be/TFCeZJi8-OI?t=274' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Agora repita o mesmo processo para enviar a Carta de Concessão. Clique no botão <strong className='ind-btn'>"Carta de Concessão /PDF"</strong> — o sistema abrirá a tela de documentos do seu celular.</p>
            <p><span className='roman'>II)</span> Procure pelos arquivos baixados (CNIS e Carta de Concessão) — geralmente eles ficam em Downloads ou Arquivos recentes.</p>
            <p><span className='roman'>III)</span> Não achou? Pode ter ido para o Drive. Abra o Drive, clique nas três linhas no canto superior esquerdo, depois em <strong className='ind-btn'>“Recentes”</strong>, depois em <strong className='ind-btn'>“meu drive”</strong>.</p>
          </ul>
          <p>Verifique se os dois arquivos estão carregados corretamente — o site mostrará o nome de cada documento logo abaixo do botão.</p>

          <h5 id="aceitando-termos" className='top-margin'>4.3 - Termos de uso</h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Após anexar os documentos, leia e confirme os Termos de Uso. Se tudo estiver certo, clique em <strong className='ind-btn'>“Resultado”</strong> para seguir para a próxima etapa.</p>
          </ul>






          {/* 5- CRIANDO SUA CONTA */}

          <h3 id="criando-conta" className='medium-top-margin underline'>5. Criando sua conta de acesso</h3>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Informe seu e-mail para resposta e número do whatsapp para confirmação do e-mail.  <a href='https://youtu.be/TFCeZJi8-OI?t=325' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></p>
            <p><span className='roman'>II)</span> Em seguida, crie uma senha segura.</p>
            <p><span className='roman'>III)</span> Depois de criar sua senha, clique em <strong className='ind-btn'>“Continuar”</strong>.</p>
          </ul>





          {/* 6- CONFIRMANDO SUA CONTA */}

          <h3 id="confirmando-conta" className='medium-top-margin underline'>6. Confirmando sua conta</h3>
          <p>Você pode confirmar seu cadastro de duas formas:</p>

          <h5 id="confirmando-conta-whats" className='top-margin'>6.1 - Confirmando pelo WhatsApp - <a href='https://youtu.be/TFCeZJi8-OI?t=379' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>II)</span> Abra a mensagem que enviamos e clique no botão <strong className='ind-btn'>"Confirme seu e-mail"</strong>.</p>
            <p><span className='roman'>II)</span> Depois de criar sua senha, clique em <strong className='ind-btn'>“Continuar”</strong>.</p>
          </ul>


          <h5 id="confirmando-conta-email" className='top-margin'>6.2 - Confirmando pelo e-mail - <a href='https://youtu.be/TFCeZJi8-OI?t=421' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Verifique se o link chegou na caixa de entrada, pode demorar até 2 minutos para chegar.</p>
            <p><span className='roman'>II)</span> Abra o e-mail que enviamos e clique no link.</p>
          </ul>

          <p className='top-margin dark-green-underline'>Atenção!</p>
          <p className='top-margin'>Caso o e-mail não esteja na caixa de entrada, ele pode ter ido para a pasta de spam.</p>
          <p>Para abrir a pasta de spam, clique nos 3 pontos no canto superior esquerdo da tela, depois clique em <strong className='ind-btn'>"spam"</strong>, pronto, aí está o e-mail.</p>
          <p>Abra a mensagem e clique no link para validar seu acesso.</p>

          <p className='top-margin'>Caso não tenha chegado, volte ao site e clique em <strong className='ind-btn'>“Reenviar link por e-mail”</strong>, se você fez essa confirmação pelo e-mail não precisa fazer pelo whatsapp.</p>






          {/* 7- PAGAMENTO */}

          <h3 id="iniciando-pagamento" className='medium-top-margin underline'>7. Pagamento</h3>

          <h5 id="preenchendo-dados-pagamento" className='top-margin'>7.1 - Preenchendo seus dados - <a href='https://youtu.be/TFCeZJi8-OI?t=470' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <p>Preencha a ficha. Atenção com o número do CPF. Deve ser o mesmo do CNIS e da Carta de Concessão.</p>


          <h5 id="escolhendo-forma-pagamento" className='top-margin'>7.2 - Escolhendo forma de pagamento - <a href='https://youtu.be/TFCeZJi8-OI?t=484' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <p>Você pode escolher a forma que preferir, clicando na bolinha para forma de pagamento desejada.</p>


          <h5 id="pagamento-pix" className='top-margin'>7.3 - Pagando pelo pix - <a href='https://youtu.be/TFCeZJi8-OI?t=487' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <p>Pix, para quem quer rapidez e praticidade.</p>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span>  Escaneie o QR Code para pagar diretamente ou clique em <strong className='ind-btn'>“Copiar”</strong> para utilizar o código <strong className='ind-btn'>“Copia e Cola”</strong>.</p>
            <p><span className='roman'>II)</span> Abra o aplicativo do seu banco clique em <strong className='ind-btn'>“pix copia e cola”</strong> cole o código no seu banco e efetue o pagamento pix.</p>
          </ul>

          <h5 id="pagamento-cartao" className='top-margin'>7.4 - Pagando pelo cartão de crédito - <a href='https://youtu.be/TFCeZJi8-OI?t=500' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <p>Cartão de crédito, para parcelar com tranquilidade.</p>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span>  Se o pagamento for com cartão de outra pessoa, ative antes a opção <strong className='ind-btn'>“Pagar com cartão de outra pessoa”</strong> e preencha os dados do pagador. </p>
            <p><span className='roman'>II)</span> Após preencher os dados do cartão, clique em <strong className='ind-btn'>“Finalizar”</strong>.</p>
          </ul>


          <h5 id="pagamento-confirmado" className='top-margin'>7.5 - Pagamento confirmado - <a href='https://youtu.be/TFCeZJi8-OI?t=521' target='blank' style={{ cursor: "pointer" }}><u>Vídeo</u></a></h5>
          <p>Após o pagamento confirmado, você verá a tela de agradecimento.</p>
          <p>Isso significa que recebemos seu pedido com sucesso e seu resultado já está disponível!</p>
          <p>Para acessar seu resultado!<strong className='ind-btn'>“Acessar área do usuário”</strong>.</p>




          {/* 8- ACESSANDO RESULTADO */}

          <h3 id="acessando-resultados" className='medium-top-margin underline'>8. Acessando seus resultados</h3>
          <p>Seu resultado fica disponível na Área do Usuário. Você precisa estar logado ara acessar a Área de Usuário.</p>
          <p>Clique <a onClick={() => handleNavigation(navigate, '/user-area')}>Aqui</a> para acessar, ou use o menu superior sempre que quiser navegar para a Área do Usuário.</p>
          <ul className="ajuda-list">
            <p><span className='roman'>I)</span> Para baixar o Relatório, Resultado e também a Nota fiscal, clique nos ícones dos arquivos. Eles vão direto para os arquivos do seu celular.</p>
          </ul>


          <p className='medium-top-margin agradecimento'>A equipe Revisa Já Aposentadoria agradece pela confiança e deseja que sua revisão traga ótimos resultados!</p>

        </div>


        <div>
          <button className='medium-top-margin' type="button" onClick={() => handleAnchorNavigation(navigate, '/', 'topo')}>
            Voltar
          </button>
        </div>

      </div>


    </div>
  );
};

export default Ajuda;